export const SET_FILTER_STATE = 'SET_FILTER_STATE'
export const RESET_FILTER_STATE = 'RESET_FILTER_STATE'
export const SET_BREADCRUMB_RECORD_NAME = 'SET_BREADCRUMB_RECORD_NAME'
export const RESET_BREADCRUMB_RECORD_NAME = 'RESET_BREADCRUMB_RECORD_NAME'
export const SET_PENDING_REQUEST_TOTAL_COUNT = 'SET_PENDING_REQUEST_TOTAL_COUNT'
